import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import PageHeader from "../../components/PageHeader";
import Carousel from "react-multi-carousel";
import { facilitiesList } from "../../Data";
import "react-multi-carousel/lib/styles.css";

export default function FacilitiesPage() {
  const ButtonGroup = ({ next, previous, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;

    return (
      <div>
        <button
          className={`${
            currentSlide === 0 ? "opacity-0 disabled:" : " opacity-100"
          } absolute -left-4 md:top-[52px] top-9 rounded-full md:w-9 md:h-9 w-8 h-8 bg-white  flex items-center justify-center cursor-pointer opacity-80`}
          onClick={() => previous()}
        >
          <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.05375 5.99994L7.65375 10.5999L6.6 11.6537L0.94625 5.99994L6.6 0.346191L7.65375 1.39994L3.05375 5.99994Z"
              fill="#1C1B1F"
            />
          </svg>
        </button>
        {/* <button
          className="bg-blue-500 text-white p-2 rounded-full"
          onClick={() => next()}
        >
          ▶️
        </button> */}
        <button
          onClick={() => next()}
          className={`absolute -right-4 z-40 md:top-[52px] top-9 rounded-full md:w-9 md:h-9 w-8 h-8 bg-white  flex items-center justify-center cursor-pointer opacity-80`}
        >
          {" "}
          <svg
            className="z-20"
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.94625 5.99994L0.346252 1.39994L1.4 0.346191L7.05375 5.99994L1.4 11.6537L0.346252 10.5999L4.94625 5.99994Z"
              fill="#1C1B1F"
            />
          </svg>
        </button>
      </div>
    );
  };

  return (
    <div>
      <Navbar />
      <main className="">
        <PageHeader
          pageTitle={"FACILITIES"}
          description={
            " Read more about us. Our history, mission, vision and many other you might love."
          }
        />
        <div className=" responsive-padding my-14 grid gap-8">
          <div className=" flex flex-col gap-3">
            <h1 className=" font-montserrat font-semibold text-2xl md:text-3xl laptopSm:text-4xl text-text-normal">
              Facilities at JMIF
            </h1>
            <p className="font-notoSans font-light text-sm leading-6 tracking-[0.06em] text-grey-normal">
              At JMIF, we are proud to offer a range of state-of-the-art
              facilities designed to enhance the learning experience and support
              the holistic development of our students:
            </p>
          </div>

          <div className="w-full overflow-hidden   relative">
            <Carousel
              additionalTransfrom={0}
              arrows={true}
              //   customButtonGroup={<ButtonGroup />}
              autoPlay
              autoPlaySpeed={5000}
              centerMode={false}
              className="h-full w-full relative "
              itemClass="h-full w-full relative" // Ensure each item takes the full height
              containerClass="h-full relative"
              dotListClass=""
              draggable
              focusOnSelect={false}
              infinite={false}
              keyBoardControl={true}
              minimumTouchDrag={80}
              pauseOnHover={true}
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={true}
              renderDotsOutside={false}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024,
                  },
                  items: 1,
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 1,
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464,
                  },
                  items: 1,
                },
              }}
              rewind
              rtl={false}
              shouldResetAutoplay
              showDots={false}
              sliderClass=""
              slidesToSlide={1}
              swipeable
            >
              {facilitiesList.map((items, index) => (
                <div key={index} className="w-full h-full">
                  <div className="w-full h-[106px] lg:h-[280px]">
                    <img
                      src={items.image}
                      alt={items.image}
                      className="w-full h-full object-cover object-center rounded-t-lg"
                    />
                  </div>

                  <div className="bg-secondary-dark px-4 py-2 lg:px-5 lg:py-3 rounded-b-lg">
                    <h1 className=" uppercase font-montserrat font-semibold text-base md:text-lg laptopSm:text-2xl text-grey-light">
                      {items.name}{" "}
                    </h1>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
